import styled from 'styled-components';

export const Container = styled.div`
  color: var(--primary_color);
  background-color: var(--white);
  border-radius: 1.2rem;

  .product-title {
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 2rem;
  }

  .product-container {
    display: flex;
    gap: 1rem;
    justify-content: center;
  }

  .product-references-rating-actions {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    color: var(--gray);
    margin-left: 6rem;

    > div {
      padding: 0 1rem;
    }
  }

  .product-references,
  .product-rating {
    border-right: 1px solid var(--white_gray);
    height: 2rem;
  }

  .product-references a,
  .product-references strong {
    margin-left: 0.4rem;
    color: var(--primary_color);
    font-weight: 700;
  }

  .product-references .brand-link {
    margin: 0;
  }

  .product-rating {
    cursor: pointer;
    gap: 0.4rem;

    .product-number-reviews {
      text-decoration: underline;
    }
  }

  .product-rating,
  .rating .stars,
  .evaluate .stars {
    display: flex;
    align-items: center;
  }

  .rating .stars,
  .evaluate .stars {
    gap: 0.2rem;
  }

  .product-actions {
    display: flex;
    gap: 0.8rem;
  }

  .product-actions .icon {
    cursor: pointer;
  }

  .product-details.mobile .group-selos-tarja {
    display: none;
  }

  .Selo.frete-gratis {
    position: absolute;
    top: 0.5rem;
    left: -2.3rem;
    width: 100%;
    max-width: 7rem;
    z-index: 4;

    & + .icons-list {
      top: 2.5rem;
    }
  }

  .Selo.Ultradesconto {
    position: absolute;
    top: 0.5rem;
    right: 0;
    width: 100%;
    max-width: 3.5rem;
    z-index: 4;
  }

  .Selo.CIMED {
    position: absolute;
    bottom: 0.5rem;
    left: -2.3rem;
    width: 100%;
    max-width: 3.5rem;
    z-index: 4;
  }

  .promotion-selo {
    justify-self: center;
    width: 100%;
    overflow: hidden;

    &.web {
      padding-right: 0.5rem;
    }

    &.mobile {
      display: none;
    }
  }

  .product-images {
    user-select: none;
    display: flex;
    align-items: center;
    gap: 4rem;
    width: 100%;
    margin-top: 3rem;
  }

  .principal-image .icons-list {
    position: relative;
    left: -2.3rem;
  }

  .principal-image {
    position: relative;
    width: calc(100% - 4rem - 2rem);
  }

  .product-images-carousel .Selo.frete-gratis {
    left: 0;
  }

  .principal-image .img-zoom-container,
  .product-images-carousel .img-zoom-container {
    position: relative;
  }

  .principal-image .img-zoom-container img,
  .product-images-carousel .img-zoom-container img {
    position: relative;
    z-index: 3;
    width: 100%;
    max-width: 30rem;
    object-fit: contain;
  }

  .principal-image .img-zoom-container img:not(.tag),
  .product-images-carousel .img-zoom-container img:not(.tag) {
    opacity: 1;
    z-index: 3;
    position: relative;
    display: block;
    background-color: var(--white);
  }

  .principal-image .img-zoom-container img:not(.tag):hover,
  .product-images-carousel .img-zoom-container img:not(.tag):hover {
    opacity: 0;
    cursor: zoom-in;
  }

  .principal-image .img-zoom-lens,
  .product-images-carousel .img-zoom-lens {
    position: absolute;
    border: 1px solid var(--gray_light);
    width: 70%;
    height: 70%;
    opacity: 0;
    z-index: 2;
  }

  .principal-image .img-zoom-container .img-zoom-result,
  .product-images-carousel .img-zoom-container .img-zoom-result {
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid var(--gray_light);
    width: calc(100% - 2rem);
    height: 100%;
    border-radius: 0.4rem;
    background-repeat: no-repeat;
  }

  .product-details {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 45rem;

    .icons-list {
      position: relative;
      flex-direction: row;
      top: 0;
      left: 0;
      height: 2.2rem;
      flex-wrap: wrap;
      gap: 0.4rem;

      .icon-container {
        cursor: default !important;

        &.UltraDesconto {
          min-width: 9.8rem;
        }

        &.DescontoProgressivo {
          display: none;
        }

        &.PossuiGenerico {
          min-width: 6.16rem;
        }

        &.BloqueadoVendaSite {
          min-width: 8.6rem;
        }

        &.VendaControlada {
          min-width: 10rem;
        }
      }
    }

    .product-details-sold-freight-gift {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      gap: 0.6rem;

      .product-sold-by-company {
        display: flex;
        align-items: center;
        font-size: 0.8rem;
        font-weight: 500;
        gap: 0.6rem;

        img {
          width: 7rem;
        }
      }

      .product-stock {
        padding-left: 0.4rem;
        border-left: 1px solid var(--gray_light);
        font-size: 0.8rem;
        font-weight: 900;

        &.available {
          color: var(--blue_light);
        }

        &.not-available {
          color: var(--red);
        }
      }
    }

    .product-price-info {
      margin-bottom: 1rem;

      p.subtitle {
        font-size: clamp(0.6rem, 2vw, 1.2rem);
        width: 3.5rem;
      }

      .product-old-price-info,
      .product-price-parcel span,
      .product-price-pix b,
      .product-price-for span {
        font-size: clamp(0.7rem, 5vw, 2rem);
        font-weight: 600;
        white-space: nowrap;
      }

      .product-old-price-info {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: max-content;
        color: var(--gray_bold);
        font-weight: 600;

        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: max-content;
          margin-left: 1rem;
          gap: 0.3rem;
        }
      }

      .product-old-price {
        position: relative;
        margin-left: 0.4rem;

        .product-x-price-old {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          transform: translate(-50%, -50%);
        }

        .product-x-price-old::before {
          transform: translate(-50%, -50%) rotate(10deg);
        }

        .product-x-price-old::after {
          transform: translate(-50%, -50%) rotate(-10deg);
        }

        .product-x-price-old::before,
        .product-x-price-old::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 1px;
          background-color: var(--red);
          transform-origin: center;
          top: 50%;
          left: 50%;
        }
      }

      .product-price-parcel {
        display: flex;
        align-items: center;
        font-size: clamp(0.6rem, 2vw, 1.4rem);
        color: rgb(64, 64, 64);
        font-weight: 500;

        span {
          color: var(--primary_color);
        }

        p:not(.subtitle) {
          margin-left: 0.5rem;
        }

        > div {
          display: flex;
          align-items: center;
        }
      }

      .product-price-pix {
        display: flex;
        align-items: center;
        color: var(--red);
      }

      .product-discount-parcel {
        display: flex;
        flex-direction: column;
        font-size: clamp(0.6rem, 2vw, 1rem);
        font-weight: 500;
        color: var(--red);
      }

      .product-price-for-info {
        display: flex;
        margin-bottom: 1rem;

        > div {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .product-parcel,
        .product-payment-discount {
          font-weight: 700;
          color: var(--blue_light);
        }
      }

      .product-price-for {
        position: relative;
      }

      .tag-discount {
        font-size: clamp(0.6rem, 2vw, 1.4rem);
        font-weight: 500;
        padding: 0.4rem 0.8rem;
        font-weight: 700;
        color: var(--white);
        background-color: var(--red);
        width: auto;
        white-space: nowrap;
        align-self: center;
        text-align: center;
        width: 100%;
      }

      .so-club-cashback {
        display: flex;
        gap: 0.2rem;
        color: var(--green_so_club);
        border: 1px solid var(--green_so_club);
        font-size: 0.7rem;
        padding: 0.5rem;
        text-align: center;
        width: 100%;
      }
    }

    .send-recipe button {
      margin: 1rem 0 2rem 0;
      padding: 0.8rem 5.8rem;
      width: max-content;
      font-size: 0.8rem;
      text-transform: none;
      color: var(--primary_color);
      background-color: var(--white);
    }

    .product-actions-buttons {
      display: flex;
      gap: 1rem;
      height: 100%;
      max-height: 4rem;
      margin-bottom: 1rem;

      .item-counter {
        max-width: 9rem;

        input,
        .fake-value {
          font-size: 1.4rem;
        }

        .input-wrapper,
        input,
        .fake-value,
        .shopping-icon {
          width: 4.25rem;
        }

        .shopping-icon {
          height: 1.1rem;
        }
      }

      .button-component {
        font-size: 1rem;
        max-width: 11rem;

        &:hover {
          color: var(--white);
          background-color: var(--primary_color);
        }
      }

      .button-component-outline {
        font-size: 0.8rem;
        font-weight: 400;
        font-style: italic;
        max-width: 12rem;

        .icon {
          width: 1.3rem;
          height: 1.3rem;
        }

        .shopping-icon {
          display: none;
        }

        &:hover .shopping-icon {
          display: inline-block;
        }

        &:hover .shopping-blue-icon {
          display: none;
        }
      }
    }

    .generic-and-similar {
      cursor: pointer;
      margin-top: 1.4rem;
      padding: 0.4rem 0.8rem;
      width: max-content;
      color: var(--white);
      background-color: var(--blue_light);
      font-weight: 700;
      border: 1px solid var(--blue_light);
      border-radius: 0.4rem;

      &:hover {
        color: var(--primary_color);
        background-color: var(--white);
        border-color: var(--primary_color);
      }
    }
  }

  @media (max-width: 1500px) {
    .product-references-rating-actions {
      margin-left: 0;
      margin-bottom: 1rem;
    }
  }

  @media (max-width: 1350px) {
    .product-references-rating-actions {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: minmax(min-content, auto);
      grid-template-areas:
        'item1 item1 item2'
        'item1 item1 item3';
    }

    .product-references-rating-actions .product-references {
      grid-area: item1;
    }

    .product-references-rating-actions .product-rating {
      grid-area: item2;
      border: 0;
    }

    .product-references-rating-actions .product-actions {
      grid-area: item3;
      justify-content: center;
      border: 0;
    }
  }

  @media (max-width: 1200px) {
    .product-container {
      align-items: center;
      flex-direction: column;
    }

    .product-references-rating-actions {
      display: flex;
      align-items: center;
    }

    .product-references-rating-actions .product-references,
    .product-references-rating-actions .product-rating {
      border-right: 1px solid var(--white_gray);
    }

    .principal-image {
      width: max-content;
    }

    .product-details .group-selos-tarja,
    .product-details .product-details-sold-freight-gift,
    .product-details .product-price-info,
    .product-details .send-recipe,
    .product-details .gift,
    .product-details .product-actions-buttons,
    .generic-and-similar {
      align-self: center;
    }

    .product-not-available {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 1rem;
    }

    .product-descriptions-info .description-block {
      height: 7.5rem;
    }
  }

  @media (max-width: 768px) {
    .promotion-selo.mobile {
      display: flex;
    }

    .product-container {
      align-items: normal;
    }

    .product-title {
      font-size: 2rem;
    }

    .product-references-images-tags-cards {
      display: flex;
      flex-direction: column;
    }

    .product-references-rating-actions {
      margin: 0;
      justify-content: center;
    }

    .product-references-rating-actions .product-references {
      padding-left: 0;
    }

    .product-images {
      display: none;
      gap: 2rem;
      flex-direction: row-reverse;
      margin-top: 1rem;
      justify-content: center;

      .icons-list .icon-container,
      .icons-list .icon-container img {
        width: 2rem;
        height: 2rem;
      }
    }

    .principal-image {
      .img-zoom-container .img-zoom-result {
        width: calc(100% - 4rem);
      }

      .novidade-tarja.secondary {
        display: none;
      }

      .icons-list {
        top: 0;
      }
    }

    .product-images-carousel {
      display: inline-block;
    }

    .product-details .group-selos-tarja {
      display: none;
    }

    .product-details.mobile {
      margin-top: 1rem;
    }

    .product-details.mobile .group-selos-tarja {
      align-self: flex-start;
    }

    .product-details.mobile .group-selos-tarja,
    .product-details.mobile .group-selos-tarja .product-tarjas {
      display: flex;
      margin-bottom: 0;
      flex-wrap: wrap;
    }

    .product-details.mobile .tarjas {
      font-size: 0.7rem;
    }

    .product-details.mobile .icons-list {
      height: 100%;
      gap: 0.4rem;
    }

    .product-details.mobile .icons-list .icon-container {
      height: 2.3rem;
    }

    .send-recipe button {
      width: 100%;
      max-width: 19rem;
      padding: 0.8rem 4.8rem;
    }

    .product-freight {
      flex-direction: column-reverse;

      > div {
        align-self: center;
      }
    }

    .previously-viewed {
      padding: 0 1rem;
    }

    .Selo.CIMED {
      left: 0;
    }
  }

  @media (max-width: 520px) {
    .product-title {
      font-size: 1.8rem;
    }

    .product-references-rating-actions {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: minmax(min-content, auto);
      grid-template-areas:
        'item1 item1 item2'
        'item1 item1 item3';

      .product-references {
        grid-area: item1;
      }

      .product-rating {
        grid-area: item2;
        border: 0;
      }

      .product-actions {
        grid-area: item3;
        justify-content: center;
        border: 0;
      }
    }

    .product-not-available {
      span {
        font-size: 1.5rem;
      }

      button {
        font-size: 0.9rem;
        padding: 0.8rem 3.3rem;
      }
    }

    .product-details .product-actions-buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      grid-template-areas: 'item1 item2';
      max-height: 100%;
      width: 100%;

      .item-counter {
        grid-area: item1;
        max-width: 100%;

        button {
          /* width: 100%; */
        }

        input {
          max-width: 6rem;
        }
      }

      .button-component {
        width: 100%;
        max-width: 100%;
        grid-area: item2;
      }

      .button-component-outline {
        width: 100%;
        max-width: 100%;
        grid-area: item3;
        gap: 1rem;

        img {
          width: 1.6rem;
          height: 1.6rem;
        }
      }
    }
  }

  @media (max-width: 400px) {
    .product-title {
      font-size: 1.4rem;
    }

    .product-references-rating-actions {
      justify-content: flex-start;
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        'item1 item1'
        'item2 item3';
      grid-gap: 0.4rem;

      .product-references {
        border: 0;
        height: 100%;
      }

      .product-rating {
        border-right: 1px solid var(--white_gray);
      }
    }

    .product-images {
      gap: 1rem;
      width: 90%;
    }

    .product-images .product-image,
    .product-images .left-carousel {
      width: 90%;
    }

    .product-details {
      .product-details-sold-freight-gift {
        flex-direction: column;

        .product-stock {
          border: 0;
        }
      }

      .product-not-available span {
        font-size: 1rem;
      }

      .product-not-available button {
        font-size: 0.7rem;
        padding: 0.4rem 2.8rem;
      }

      .product-price-info {
        align-self: flex-start;

        .product-price-for-info .product-price-for {
          font-size: 2rem;
        }

        .tag-discount {
          font-size: clamp(0.6rem, 2vw, 1rem);
          padding: 0.2rem 0.4rem;
        }
      }

      .send-recipe button {
        padding: 0.8rem 3.8rem;
      }
    }
  }

  @media (max-width: 380px) {
    .product-details .product-price-info p.subtitle {
      width: 2rem;
    }

    .product-details .product-actions-buttons {
      grid-template-areas:
        'item1 item1'
        'item2 item2';

      .item-counter {
        button {
          width: 100%;
        }

        .input-wrapper {
          width: 100%;
        }

        input {
          max-width: 6rem;
        }
      }
    }
  }

  @media (max-width: 320px) {
    .product-details
      .product-details-sold-freight-gift
      .product-sold-by-company {
      flex-direction: column;
    }

    .so-club-cashback,
    .product-price-parcel > div {
      flex-direction: column;
    }

    .product-details .product-price-info .product-price-parcel {
      p:not(.subtitle) {
        margin-left: 0;
      }

      > div {
        align-items: flex-start;
      }
    }
  }
`;
